import { NavigationError } from '@angular/router';

const RELOAD_KEY = 'chunk-reload-at';

/**
 * Aba aberta antes de um deploy ainda roda o build anterior, que tenta carregar páginas
 * (chunks) que o build novo apagou. Nesse caso recarrega uma vez direto na rota pedida,
 * já com o build novo. A marca no sessionStorage evita loop se o erro for outro.
 */
export function reloadOnStaleChunk(error: NavigationError): void {
  const message = String(error.error?.message ?? error.error ?? '');
  const isStaleChunk = /dynamically imported module|Importing a module script failed|error loading dynamically imported module/i
    .test(message);
  if (!isStaleChunk) {
    return;
  }
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
    if (Date.now() - last < 10000) {
      return;
    }
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // Sem sessionStorage (aba privada etc.): recarrega mesmo assim.
  }
  window.location.assign(error.url);
}
